var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Solid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.575 197.923c14.13-14.342 30.693-21.923 47.9-21.923h60.584l-23.03 23.029a24 24 0 0 0 33.942 33.942l64-64a24 24 0 0 0 0-33.942l-64-64a24 24 0 0 0 -33.942 33.942l23.03 23.029h-60.584c-35.925 0-68.858 18.069-92.555 48.078a188.625 188.625 0 0 1 24.28 51.641 108.261 108.261 0 0 1 20.375-29.796z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.452 314.077c-14.131 14.342-30.695 21.923-47.901 21.923h-92.551a24 24 0 0 0 0 48h92.551c35.924 0 68.858-18.069 92.555-48.078a188.625 188.625 0 0 1 -24.283-51.641 108.281 108.281 0 0 1 -20.371 29.796z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.971 279.029a24 24 0 0 0 -33.942 33.942l23.03 23.029h-60.584c-17.207 0-33.77-7.581-47.9-21.923-15.187-15.415-26.194-37.649-30.994-62.609-13.981-72.697-65.806-123.468-126.03-123.468h-92.551a24 24 0 0 0 0 48h92.551c17.206 0 33.77 7.581 47.9 21.923 15.186 15.414 26.193 37.649 30.993 62.609 13.981 72.696 65.806 123.468 126.031 123.468h60.584l-23.03 23.029a24 24 0 0 0 33.942 33.942l64-64a24 24 0 0 0 0-33.942z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.71b8622b.svg";
export { ForwardRef as ReactComponent };